import React, { lazy, Suspense, useMemo } from 'react'
import { Helmet } from 'react-helmet'
import { useSelector } from 'react-redux'
import LoadingBackgroundPage from 'src/components/LoadingBackgroundPage/LoadingBackgroundPage'
import StaticPage from 'src/components/StaticPage/StaticPage'
import {
  selectAppName,
  selectBrandName,
  selectExternalFAQUrl,
} from 'src/redux/selectors/session.selectors'
const FAQ: React.FC = () => {
  const brandName = useSelector(selectBrandName)
  const externalFAQUrl = useSelector(selectExternalFAQUrl)
  const appName = useSelector(selectAppName)

  const FAQComponent = useMemo(
    () =>
      externalFAQUrl === undefined
        ? lazy(() => import(`src/branded/${brandName}/FAQ/FAQ`))
        : (): null => {
            window.location.href = externalFAQUrl
            return null
          },
    [brandName],
  )

  return (
    <StaticPage>
      <Helmet>
        <title>{`Frequently Asked Questions about ${appName}`}</title>
        <meta
          name="description"
          content={`The Frequently Asked Questions answers the most common questions about ${appName}.`}
        />
      </Helmet>
      <Suspense fallback={<LoadingBackgroundPage />}>
        <FAQComponent />
      </Suspense>
    </StaticPage>
  )
}

export default FAQ
